import Loadable from 'react-loadable';

const Cookie = Loadable({
  loader: () => import('./lazy'),
  loading: () => null,
});

export default Cookie;
